export default __webpack_public_path__ + "static/1359-4d6043ee9addfdec059e7ed5c666c71a.gif";